import axios from "axios";

// Hub base URL is injected per-site by the WordPress sub-site plugin via a
// `window.sjd_booking_hub_url` inline script (see sjd-booking.php). This lets
// the same bundle target a staging hub, a local test hub, or production
// without rebuilding. We keep the production URL as the last-resort fallback
// so a misconfigured or offline sub-site still boots instead of crashing.
const FALLBACK_HUB_URL = "https://bookings.sjdtaxi.com/wp-json/api/v1/";

const resolveHubUrl = (): string => {
  const injected =
    typeof window !== "undefined"
      ? (window as unknown as { sjd_booking_hub_url?: string })
          .sjd_booking_hub_url
      : undefined;
  const trimmed = typeof injected === "string" ? injected.trim() : "";
  return trimmed !== "" ? trimmed : FALLBACK_HUB_URL;
};

export const baseUrl = resolveHubUrl();

axios.defaults.baseURL = baseUrl;

export default axios;
